// src/services/errorLogger.js
import axiosClient from "../api/axiosClient";

export async function logError(payload) {
  try {
    await fetch("/api/errors/frontend/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
  } catch (err) {
    console.error("Failed to log error", err);
  }
}



export async function logFrontendError(
  payload
) {
  try {
    await axiosClient.post(
      "/monitoring/frontend-errors/",
      payload
    );
  } catch (e) {
    console.error(
      "Error logging failed",
      e
    );
  }
}